export default __webpack_public_path__ + "media/images/brands/xpress/services/service-07-a2d6a46308d585ce24f41b0621bb85b3.jpg";